"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Licenses = void 0;

var _react = _interopRequireWildcard(require("react"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _skybaseComponents = require("../../skybase-components");

var _shapes = require("../../skybase-core/shapes");

var _sbFetch = require("../../skybase-core/services/sb-fetch");

var _actions = require("./actions");

var _constants = require("./constants");

var _utils = require("./utils");

var _licensesI18n = require("./licenses-i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _Licenses = /*#__PURE__*/function (_Component) {
  _inherits(_Licenses, _Component);

  var _super = _createSuper(_Licenses);

  function _Licenses() {
    var _this;

    _classCallCheck(this, _Licenses);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "loadLicences", function () {
      var _this$props = _this.props,
          handleDispatchSetLicensesData = _this$props.handleDispatchSetLicensesData,
          licenses = _this$props.licenses,
          manifestUrls = _this$props.manifestUrls; // If we don't have data already saved to store, perform AJAX requests and save them.

      if (licenses.length === 0) {
        manifestUrls.forEach(function (url) {
          (0, _sbFetch.sbFetch)(url).then(function (body) {
            if (body.packages) {
              var licensesData = (0, _sortBy.default)(body.packages, function (license) {
                return license.name.toLowerCase();
              });
              handleDispatchSetLicensesData(licensesData);
            }
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDownloadZip", function (files, moduleName) {
      var staticFilesPath = _this.props.staticFilesPath;
      (0, _utils.downloadLicenseFilesAzZip)(files, moduleName, staticFilesPath);
    });

    _defineProperty(_assertThisInitialized(_this), "cellFormatter", function (value, attributeName, row) {
      if (attributeName === 'licenseFiles') {
        var _ = _this.props.intl.formatMessage;
        var id = row.id,
            name = row.name,
            version = row.version;
        var licenseId = (0, _utils.constructIdForLicense)(id, name, version, 'download-license');
        return /*#__PURE__*/_react.default.createElement("a", {
          className: "license-download-files",
          onClick: function onClick() {
            return _this.handleDownloadZip(value, name);
          },
          id: licenseId
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "sbi-download-filled"
        }), _(_licensesI18n.messages.download));
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "getColumns", function () {
      var _ = _this.props.intl.formatMessage;
      return [{
        name: 'name',
        label: _(_licensesI18n.messages.name)
      }, {
        name: 'version',
        label: _(_licensesI18n.messages.version)
      }, {
        name: 'licenseFiles',
        label: /*#__PURE__*/_react.default.createElement("div", {
          className: "title-with-tooltip"
        }, _(_licensesI18n.messages.downloadLicenseFiles), /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbHint, {
          hintClassName: "license-header-question-tooltip",
          hintData: _(_licensesI18n.messages.aZipFileWillBeDownloaded),
          position: {
            vertical: 'top',
            horizontal: 'center'
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "question-tooltip-data"
        }, '?')))
      }];
    });

    return _this;
  }

  _createClass(_Licenses, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadLicences();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          id = _this$props2.id,
          licenses = _this$props2.licenses;
      return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbDataTable, {
        className: (0, _classnames.default)('licenses-wrapper', className),
        id: id,
        asyncData: false,
        columns: this.getColumns(),
        data: licenses,
        enablePagination: true,
        paginationProps: {
          className: 'm-b-20',
          pageSizeDropdownProps: {
            menuPosition: 'top-left'
          }
        },
        cellFormatter: this.cellFormatter
      });
    }
  }]);

  return _Licenses;
}(_react.Component);

_defineProperty(_Licenses, "propTypes", {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  licenses: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    version: _propTypes.default.string,
    license: _propTypes.default.string,
    licenseFiles: _propTypes.default.array,
    sourceDirectory: _propTypes.default.string,
    className: _propTypes.default.string,
    id: _propTypes.default.string
  })),
  handleDispatchSetLicensesData: _propTypes.default.func.isRequired,
  manifestUrls: _propTypes.default.arrayOf(_propTypes.default.string),
  staticFilesPath: _propTypes.default.string,
  intl: _shapes.intlShape.isRequired
});

_defineProperty(_Licenses, "defaultProps", {
  className: null,
  id: null,
  licenses: [],
  manifestUrls: ['/static/license-manifest-ui.json', '/static/license-manifest.json'],
  staticFilesPath: '/static/licenses'
});

var mapStateToProps = function mapStateToProps(state) {
  var licenses = state.get ? state.get(_constants.LICENSES_STATE_KEY_NAME) : state[_constants.LICENSES_STATE_KEY_NAME];
  return {
    licenses: licenses
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleDispatchSetLicensesData: function handleDispatchSetLicensesData(licenses) {
      return dispatch((0, _actions.setLicensesData)(licenses));
    }
  };
};

var Licenses = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Licenses));
exports.Licenses = Licenses;
//# sourceMappingURL=licenses.js.map